"use strict";

(function (Drupal) {
  Drupal.behaviors.countdown = {
    attach: function attach(context, settings) {
      var countdown = context.querySelector('.c-countdown__content');
      if (!countdown) return;
      var countdownElem = context.querySelector('.c-countdown__timer');
      var eventSoonElem = context.querySelector('.c-countdown__body-after');
      var liveStreamElem = context.querySelector('.c-countdown__timer-after');
      var daysElem = context.querySelector('.days');
      var hoursElem = context.querySelector('.hours');

      // Grab the countdown date from the data-countdown-date attribute in the twig file. This is in seconds, so we need to multiply by 1000 to get milliseconds.
      var endTime = countdownElem.dataset.countdownDate * 1000;
      function updateSingularOrPluralClass(element, value) {
        if (value === 1) {
          element.classList.add('singular');
          element.classList.remove('plural');
        } else {
          element.classList.add('plural');
          element.classList.remove('singular');
        }
      }
      function updateCountdown() {
        // Grab the current time in milliseconds.
        var now = new Date();
        // Calculate the difference between the two to get remaining time.
        var timeDiff = endTime - now;
        var daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        var hoursLeft = Math.floor(timeDiff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        if (timeDiff <= 1) {
          countdownElem.style.opacity = '0';
          countdownElem.offsetHeight; // Trigger a reflow in between the opacity change, otherwise you get some wonky DOM rewriting. This allows the animated transitions to work.
          countdownElem.style.display = 'none';
          eventSoonElem.style.opacity = '0';
          eventSoonElem.offsetHeight;
          eventSoonElem.style.display = 'none';
          liveStreamElem.style.display = 'flex';
          liveStreamElem.offsetHeight;
          liveStreamElem.style.opacity = '1';
        } else if (timeDiff <= 3600000) {
          countdownElem.style.opacity = '0';
          countdownElem.offsetHeight;
          countdownElem.style.display = 'none';
          eventSoonElem.style.display = 'flex';
          eventSoonElem.offsetHeight;
          eventSoonElem.style.opacity = '1';
          liveStreamElem.style.opacity = '0';
          liveStreamElem.offsetHeight;
          liveStreamElem.style.display = 'none';
        } else if (timeDiff >= 60000) {
          countdownElem.style.display = 'flex';
          countdownElem.offsetHeight;
          countdownElem.style.opacity = '1';
          eventSoonElem.style.opacity = '0';
          eventSoonElem.offsetHeight;
          eventSoonElem.style.display = 'none';
          liveStreamElem.style.opacity = '0';
          liveStreamElem.offsetHeight;
          liveStreamElem.style.display = 'none';
          if (daysLeft === 0) {
            daysElem.style.display = 'none';
            hoursElem.textContent = hoursLeft;
            updateSingularOrPluralClass(hoursElem, hoursLeft);
          } else {
            daysElem.style.display = 'block';
            daysElem.textContent = daysLeft;
            hoursElem.textContent = hoursLeft;
            updateSingularOrPluralClass(daysElem, daysLeft);
            updateSingularOrPluralClass(hoursElem, hoursLeft);
          }
        }
      }
      updateCountdown();
      // Let's check the timeDiff every minute
      setInterval(updateCountdown, 60000);
    }
  };
})(Drupal);